import React, { useState } from "react";

import arraySorter from "../../utils/sorting";
import arrayFilter from "../../utils/filtering";
import SearchField from "../../components/SearchField/SearchField";

import DeviceFilteringSelector from "../../components/DeviceCommons/DeviceSortingAndFiltering/DeviceFilteringSelector";
import DeviceSortingSelector from "../../components/DeviceCommons/DeviceSortingAndFiltering/DeviceSortingSelector";


import ExportButton from '../../components/ExportButton/ExportButton';

import { Button } from "selfly-ui-react";
import AlarmSettings from './../../components/AlarmSettings'

import './page-header.scss';

export default function PageHeader(props) {
   
    const [filters, setFilters] = useState(props.filters ? props.filters : []);
    const [sorters, setSorters] = useState(props.sorters ? props.sorters : []);

    const [searchKey, setSearchKey] = useState(props.search ? props.search : "");

    const [filtersVisibility, setFiltersVisibility] = useState(false);
    const [sortingVisibility, setsortingVisibility] = useState(false);

    //modal visibility
    const [isOpen, setIsOpen] = useState(false)


    const FilterComponent = props.filterComponent !== undefined ? props.filterComponent : DeviceFilteringSelector;

    function updateFilters(newFilters) {
        setFilters(newFilters);
        if (typeof props.onChange === "function") {
            props.onChange(newFilters, null, null);
        }
    }

    function updateSorters(newSorters) {
        setSorters(newSorters);
        if (typeof props.onChange === "function") {
            props.onChange(null, newSorters, null);
        }
    }

    function updateSearchKey(newSearchKey) {
        setSearchKey(newSearchKey);
        if (typeof props.onChange === "function") {
            props.onChange(null, null, newSearchKey);
        }
    }

    return (
        <React.Fragment>
            <div className="page-header-title-row">
                <h3>{props.title}</h3>
                <div className="buttons">

                    {props.alarmSettings &&  <Button icon="settings"  onClick={ ()=>{setIsOpen(true)} } /> }
                    {isOpen ? <AlarmSettings permissions={props.permissions} isOpen={isOpen} onClose={(value)=>{setIsOpen(value)}}/> : null}

                    <Button
                        id="ButtonToggleFilterView"
                        icon="filter_list"
                        type={filtersVisibility ? "positive" : "primary"}
                        onClick={() => {
                            setFiltersVisibility(!filtersVisibility);
                        }}
                    />
                    {props.disableSorter !== true && <Button
                        id="ButtonToggleSortView"
                        icon="sort"
                        type={sortingVisibility ? "positive" : "primary"}
                        onClick={() => {
                            setsortingVisibility(!sortingVisibility);
                        }}
                    />}
                    {typeof props.exportButton === "object" && props.exportButton !== null && <ExportButton {...props.exportButton} />}
                </div>
                <SearchField
                    onChange={val => {
                        updateSearchKey(val);
                    }}
                    disabled={props.searchDisabled}
                    value={searchKey}
                />
            </div>
            <div className={`page-header-filters ${filtersVisibility || sortingVisibility ? "open" : "closed"}`}>
                <div className="filtering-view-header">
                    <Button
                        id="ButtonCloseFilterView"
                        icon="close"
                        onClick={() => {
                            setFiltersVisibility(false);
                            setsortingVisibility(false);
                        }}
                    />
                </div>

                <div className="filtering-view-content">
                    {filtersVisibility && (
                        <FilterComponent
                            rules={filters}
                            options={props.filterOptions ? props.filterOptions : {}}
                            onChange={rules => {
                                updateFilters(rules);
                            }}
                        />
                    )}

                    {sortingVisibility && (
                        <DeviceSortingSelector
                            sortingRules={sorters}
                            onChange={rules => {
                                updateSorters(rules);
                            }}
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export function usePageHeaderState(opts) {
    
    const [origFilters] = useState(opts.filters ? opts.filters : []);
    const [filters, setFilters] = useState(origFilters);
    const [sorters, setSorters] = useState(opts.sorters ? opts.sorters : []);

    const [searchKey, setSearchKey] = useState(opts.search ? opts.search : "");

    function update(newFilters, newSorters, newSearchKey) {
       
        if (newFilters !== null) {
            setFilters(newFilters);
        }
        if (newSorters !== null) {
            setSorters(newSorters);
        }
        if (newSearchKey !== null) {
            setSearchKey(newSearchKey);
        }
    }

    const filteredItems = opts.items === 'LOADING' ? 'LOADING' : sortByRules(
        filterBySearchKey(filterByRules(opts.items, [...origFilters, ...filters]), searchKey, opts.searchFromKeys),
        sorters
    );

    return [filters, sorters, searchKey, update, filteredItems];
}

function filterBySearchKey(dataArray = [], searchKey = "", searchFromKeys = []) {
    if (searchKey.length === 0) {
        return dataArray;
    }

    return dataArray.filter(data => {
        const key = typeof searchKey === "string" ? searchKey.toUpperCase() : searchKey;
        if (key.length === 0 || typeof key !== "string") {
            return true;
        }

        // Using for - of loop instead of forEach so that we can easily exit from it without problems
        for (let fromKey of searchFromKeys) {
            const val = data[fromKey];
            if (
                typeof val === "string" &&
                val
                    .slice()
                    .toUpperCase()
                    .includes(key)
            ) {
                return true;
            }
        }

        return false;
    });
}

function filterByRules(dataArray = [], filterRules = []) {
    if (Array.isArray(dataArray)) {
        if(filterRules.length === 0) {
            return dataArray;
        }
        return arrayFilter(dataArray, filterRules);
    }
    return [];
}

function sortByRules(dataArray, sorterRules) {
    if (Array.isArray(dataArray)) {
        if(sorterRules.length === 0) {
            return dataArray;
        }
        return arraySorter(dataArray, sorterRules);
    }
    return [];
}
